
//是否显示头部
export const UPDATE_HEAD='UPDATE_HEAD';

//是否显示loading
export const UPDATE_LOADING='UPDATE_LOADING';

//是否显示footer
export const UPDATE_FOOTER='UPDATE_FOOTER';

//页面标题
export const UPDATE_PAGE_TITLE='UPDATE_PAGE_TITLE';


// WEBPACK FOOTER //
// ./src/store/data.js